
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 20","stroke-opacity":"0","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.293 1.293l-.53.53.53-.53zm5.414 5.414l.53-.53-.53.53zM8.75 8a.75.75 0 00-1.5 0h1.5zM8 14l-.53.53a.75.75 0 001.06 0L8 14zm-2.47-3.53a.75.75 0 00-1.06 1.06l1.06-1.06zm6 1.06a.75.75 0 10-1.06-1.06l1.06 1.06zM13 18.25H3v1.5h10v-1.5zM1.75 17V3H.25v14h1.5zM3 1.75h5.586V.25H3v1.5zm11.25 5.664V17h1.5V7.414h-1.5zm-5.487-5.59l5.414 5.413 1.06-1.06L9.823.763l-1.06 1.06zm6.987 5.59c0-.464-.184-.909-.513-1.237l-1.06 1.06a.25.25 0 01.073.177h1.5zM8.586 1.75a.25.25 0 01.177.073l1.06-1.06A1.75 1.75 0 008.586.25v1.5zM3 18.25c-.69 0-1.25-.56-1.25-1.25H.25A2.75 2.75 0 003 19.75v-1.5zm10 1.5A2.75 2.75 0 0015.75 17h-1.5c0 .69-.56 1.25-1.25 1.25v1.5zM1.75 3c0-.69.56-1.25 1.25-1.25V.25A2.75 2.75 0 00.25 3h1.5zm5.5 5v6h1.5V8h-1.5zm-2.78 3.53l3 3 1.06-1.06-3-3-1.06 1.06zm4.06 3l3-3-1.06-1.06-3 3 1.06 1.06z"}})])
          )
        }
      }
    